import React from 'react';
import './HelpPage.css';

const HelpPage = () => {
  return (
    <div className="help-page">
      <div className="page-content">
        <div className="help-container">
          <h1>Help & Support</h1>
          
          <div className="help-section">
            <h2>Beta Testing</h2>
            <p>
              Thanks so much for beta testing our product! If there is any issue, 
              please feel free to call/text me anytime at{' '}
              <a href="tel:778-214-3702" className="contact-link">778-214-3702</a>{' '}
              or email me at your convenience at{' '}
              <a href="mailto:jakob.solstrozberg@torontomu.ca" className="contact-link">
                jakob.solstrozberg@torontomu.ca
              </a>.
            </p>
          </div>

          <div className="help-section">
            <h2>Product Updates</h2>
            <p>
              We plan on making this product even better and will be pushing new updates 
              and bug fixes every week. If you have any suggestions, please don't hesitate 
              to let me know.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
